/**
 * Try Sampler Funnel - Multi-step form logic
 */
(function() {
  'use strict';

  const funnel = document.getElementById('try-sampler-funnel');
  if (!funnel) return;

  // State
  let currentStep = 1;
  let formData = {
    email: '',
    first_name: '',
    last_name: '',
    address1: '',
    address2: '',
    city: '',
    province: '',
    zip: '',
    phone: ''
  };

  // Elements
  const steps = funnel.querySelectorAll('.tsf-step');
  const stepIndicators = funnel.querySelectorAll('.tsf-steps__item');
  const emailForm = document.getElementById('tsf-email-form');
  const shippingForm = document.getElementById('tsf-shipping-form');
  const checkoutBtn = document.getElementById('tsf-checkout-btn');
  const backBtns = funnel.querySelectorAll('[data-action="back"]');

  // Step navigation
  function goToStep(step) {
    if (step < 1 || step > 3) return;
    
    currentStep = step;
    
    // Update step content visibility
    steps.forEach((s, i) => {
      s.classList.toggle('tsf-step--active', i + 1 === step);
    });
    
    // Update step indicators
    stepIndicators.forEach((indicator, i) => {
      const stepNum = i + 1;
      indicator.classList.toggle('tsf-steps__item--active', stepNum === step);
      indicator.classList.toggle('tsf-steps__item--complete', stepNum < step);
    });

    // Scroll to form on mobile
    const formContainer = funnel.querySelector('.tsf-form-container');
    if (formContainer && window.innerWidth < 768) {
      formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Email form submission
  if (emailForm) {
    emailForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const emailInput = document.getElementById('tsf-email');
      const email = emailInput.value.trim();
      
      if (!email || !isValidEmail(email)) {
        shakeElement(emailInput);
        return;
      }
      
      formData.email = email;
      
      // Send to Klaviyo (if available)
      if (typeof _learnq !== 'undefined') {
        _learnq.push(['identify', { '$email': email }]);
        _learnq.push(['track', 'Started Sampler Funnel', { email }]);
      }
      
      goToStep(2);
    });
  }

  // Shipping form submission
  if (shippingForm) {
    shippingForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      // Collect shipping data
      const fields = ['first_name', 'last_name', 'address1', 'address2', 'city', 'province', 'zip', 'phone'];
      let valid = true;
      
      fields.forEach(field => {
        const input = document.getElementById(`tsf-${field.replace('_', '-')}`);
        if (input) {
          formData[field] = input.value.trim();
          
          // Validate required fields
          if (input.required && !formData[field]) {
            shakeElement(input);
            valid = false;
          }
        }
      });
      
      if (!valid) return;
      
      // Track shipping step completion
      if (typeof _learnq !== 'undefined') {
        _learnq.push(['track', 'Completed Shipping Info', {
          email: formData.email,
          city: formData.city,
          state: formData.province
        }]);
      }
      
      goToStep(3);
    });
  }

  // Checkout button
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async () => {
      const variantId = funnel.dataset.variantId;
      const productHandle = funnel.dataset.productHandle;
      
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }
      
      // Disable button and show loading
      checkoutBtn.disabled = true;
      checkoutBtn.innerHTML = '<span class="tsf-spinner"></span> Processing...';
      
      try {
        // Add to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId),
              quantity: 1
            }]
          })
        });
        
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        
        // Track checkout initiation
        if (typeof _learnq !== 'undefined') {
          _learnq.push(['track', 'Started Checkout', {
            email: formData.email,
            product: productHandle
          }]);
        }
        
        // Build checkout URL with shipping info pre-filled
        let checkoutUrl = '/checkout';
        const params = new URLSearchParams();
        
        if (formData.email) params.set('checkout[email]', formData.email);
        if (formData.first_name) params.set('checkout[shipping_address][first_name]', formData.first_name);
        if (formData.last_name) params.set('checkout[shipping_address][last_name]', formData.last_name);
        if (formData.address1) params.set('checkout[shipping_address][address1]', formData.address1);
        if (formData.address2) params.set('checkout[shipping_address][address2]', formData.address2);
        if (formData.city) params.set('checkout[shipping_address][city]', formData.city);
        if (formData.province) params.set('checkout[shipping_address][province]', formData.province);
        if (formData.zip) params.set('checkout[shipping_address][zip]', formData.zip);
        if (formData.phone) params.set('checkout[shipping_address][phone]', formData.phone);
        params.set('checkout[shipping_address][country]', 'United States');
        
        const queryString = params.toString();
        if (queryString) {
          checkoutUrl += '?' + queryString;
        }
        
        // Redirect to checkout
        window.location.href = checkoutUrl;
        
      } catch (error) {
        console.error('Checkout error:', error);
        checkoutBtn.disabled = false;
        checkoutBtn.innerHTML = '🔒 Ship My Free Sampler – $9.99';
        alert('Something went wrong. Please try again.');
      }
    });
  }

  // Back buttons
  backBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      goToStep(currentStep - 1);
    });
  });

  // Utility functions
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function shakeElement(el) {
    el.classList.add('tsf-shake');
    setTimeout(() => el.classList.remove('tsf-shake'), 500);
  }

  // Initialize
  goToStep(1);

  // ==========================================================================
  // COUNTDOWN TIMER
  // ==========================================================================
  
  const countdownEl = document.getElementById('tsf-countdown-time');
  if (countdownEl) {
    // Set end time to midnight tonight (resets daily)
    function getEndTime() {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      return end;
    }
    
    function updateCountdown() {
      const now = new Date();
      const end = getEndTime();
      const diff = end - now;
      
      if (diff <= 0) {
        countdownEl.textContent = '00:00:00';
        return;
      }
      
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);
      
      countdownEl.textContent = 
        String(hours).padStart(2, '0') + ':' +
        String(mins).padStart(2, '0') + ':' +
        String(secs).padStart(2, '0');
    }
    
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  // ==========================================================================
  // STOCK COUNTER (Psychological scarcity)
  // ==========================================================================
  
  const stockEl = document.getElementById('tsf-stock-count');
  if (stockEl) {
    // Start with a believable random number, slowly decrease
    let stock = 37 + Math.floor(Math.random() * 15); // 37-51
    stockEl.textContent = stock;
    
    // Occasionally decrease stock (creates urgency)
    setInterval(() => {
      if (stock > 12 && Math.random() > 0.7) {
        stock -= 1;
        stockEl.textContent = stock;
        stockEl.style.transform = 'scale(1.2)';
        setTimeout(() => stockEl.style.transform = 'scale(1)', 200);
      }
    }, 15000 + Math.random() * 10000); // Every 15-25 seconds
  }

  // ==========================================================================
  // SOCIAL PROOF TOAST NOTIFICATIONS
  // ==========================================================================
  
  const toastEl = document.getElementById('tsf-toast');
  const toastNameEl = document.getElementById('tsf-toast-name');
  
  if (toastEl && toastNameEl) {
    const names = [
      'Sarah from Austin, TX',
      'Mike from Denver, CO',
      'Jessica from Portland, OR',
      'Chris from Nashville, TN',
      'Amanda from San Diego, CA',
      'Ryan from Phoenix, AZ',
      'Emily from Seattle, WA',
      'Jake from Miami, FL',
      'Lauren from Atlanta, GA',
      'Tyler from Charlotte, NC',
      'Ashley from Chicago, IL',
      'Brandon from Houston, TX',
      'Megan from Boston, MA',
      'Kevin from Las Vegas, NV',
      'Brittany from Philadelphia, PA'
    ];
    
    let lastIndex = -1;
    
    function showToast() {
      // Pick a random name (not the same as last)
      let index;
      do {
        index = Math.floor(Math.random() * names.length);
      } while (index === lastIndex);
      lastIndex = index;
      
      toastNameEl.textContent = names[index];
      toastEl.classList.add('tsf-toast--visible');
      
      // Hide after 4 seconds
      setTimeout(() => {
        toastEl.classList.remove('tsf-toast--visible');
      }, 4000);
    }
    
    // Show first toast after 8-15 seconds
    setTimeout(showToast, 8000 + Math.random() * 7000);
    
    // Then show randomly every 20-45 seconds
    setInterval(() => {
      if (Math.random() > 0.3) { // 70% chance to show
        showToast();
      }
    }, 20000 + Math.random() * 25000);
  }

})();
